import {useState, useCallback, useEffect} from 'react';
import EventEmitter from 'events';

export const promoCodeEventEmitter = new EventEmitter();
const PROMO_CODE_SUBMITTED = 'PromoCodeSubmitted';
const PROMO_CODE_GRANTED = 'displayPromoCodeGranted';
const SHOW_PROMO_CODE = 'showPromoCode';

export interface PromoCode {
  id: string;
  type: string;
  uses: string;
  code: string;
  cash_amount: number;
  z_amount: number;
  valid: boolean;
  deposit_required: boolean;
  lto_compatible: boolean;
}

export function usePromoCode() {
  const [isPromoCodeGrantedShown, displayPromoCodeGranted] = useState(false);
  const [promoCodeCashAmount, setPromoCodeCashAmount] = useState<string>('');
  const [promoCodeZAmount, setPromoCodeZAmount] = useState<string>('');
  const [promoCode, setPromo] = useState<PromoCode | null>(null);
  const [showPromoCode, setShowPromoCode] = useState(false);

  const togglePromoCodeGranted = useCallback(() => {
    displayPromoCodeGranted((value) => !value);
  }, []);

  useEffect(() => {
    promoCodeEventEmitter.addListener(PROMO_CODE_SUBMITTED, (promoCode: PromoCode) => {
      setPromo(promoCode);
    });
    promoCodeEventEmitter.on(
      PROMO_CODE_GRANTED,
      (display: boolean, cashAmount: string, zAmount: string) => {
        displayPromoCodeGranted(display);
        setPromoCodeCashAmount(cashAmount);
        setPromoCodeZAmount(zAmount);
      }
    );
    promoCodeEventEmitter.addListener(SHOW_PROMO_CODE, (show: boolean) => {
      setShowPromoCode(show);
    });
    return () => {
      promoCodeEventEmitter.removeAllListeners(PROMO_CODE_GRANTED);
      promoCodeEventEmitter.removeAllListeners(PROMO_CODE_SUBMITTED);
      promoCodeEventEmitter.removeAllListeners(SHOW_PROMO_CODE);
    };
  }, []);

  const setPromoCode = useCallback((promo: PromoCode) => {
    setPromo(promo);
    promoCodeEventEmitter.emit(PROMO_CODE_SUBMITTED, promo);
  }, []);

  const setShowPromoCodePrompt = useCallback((show: boolean) => {
    promoCodeEventEmitter.emit(SHOW_PROMO_CODE, show);
  }, []);

  return {
    isPromoCodeGrantedShown,
    setPromoCode,
    showPromoCode,
    setShowPromoCodePrompt,
    togglePromoCodeGranted,
    promoCodeCashAmount,
    promoCodeZAmount,
    promoCode,
  };
}
